'use client'

import classNames from 'classnames'
import { TFunction, useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'

import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import { PRODUCT_FEED_TYPE } from '@src/quince-site-common/src/services/productFeedService/productFeedService.types'
import ProductListTwo from '@src/SectionRenderer/sections/productListTwo'
import { ProductListTwoSectionConfig } from '@src/SectionRenderer/sections/productListTwo/ProductListTwo'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import styles from './search.module.scss'
import SearchResultsSection from './searchResultsSection/SearchResultsSection'

function getProductListTwoProps(t: TFunction): ProductListTwoSectionConfig {
  return {
    // @i18n-ignore
    typename: 'CustomSection',
    // @i18n-ignore
    id: 'searchPageaBestSellers',
    // eslint-disable-next-line i18next/no-literal-string
    classNames: ['background-color--offWhite'],
    influencers: [],
    layoutType: LAYOUT_TYPES.DEFAULT,
    baseDynamicClasses: [],
    mobileDynamicClassesOverrides: [],
    classNamesMobileOverrides: [],
    productFeedType: PRODUCT_FEED_TYPE.CUSTOMER_TOP_PRODUCTS,
    productFeedLimit: 4,
    productFeedMetaData: undefined,
    heading: t('best_sellers'),
    headingClassname: styles.bestsellerHeading,
  }
}

export default function SearchPageLegacy() {
  const { t } = useTranslation('common')
  // Load the search results section first, then load the product list two - CLS mitigation
  const [searchLoaded, setSearchLoaded] = useState(false)
  useEffect(() => {
    trackEvent(TELEMETRY_EVENT_NAMES.SEARCH_PAGE_VIEW, {})
  }, [])

  return (
    <>
      <SearchResultsSection setSearchLoaded={setSearchLoaded} />
      <div className={classNames(!searchLoaded && styles.searchRecommendationLoadingClass)}>
        <ProductListTwo
          sectionConfig={getProductListTwoProps(t)}
          loadingContainerClassName={styles.searchRecommendationLoadingClass}
        />
      </div>
    </>
  )
}
